import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const synchronizationDialogSelector = createSelector(
  [(state: RootState) => state.synchronizationDialog],
  ({ isOpen }) => {
    return { isOpen };
  },
);
